import { Locale as GqlTsLocale } from 'graphql-ts-types';
import { Locale } from '../enums/Locale';
export var toGQLLocale = function (locale) { return locale.slice(0, 5); };
export var toGqlTsLocale = function (locale) {
    var _a;
    return ((_a = {},
        _a[Locale.De_At] = GqlTsLocale.DeAt,
        _a[Locale.De_Ch] = GqlTsLocale.DeCh,
        _a[Locale.De_De_H24] = GqlTsLocale.DeDe,
        _a[Locale.De_De_Ffh] = GqlTsLocale.DeFfh,
        _a[Locale.Fr_Be] = GqlTsLocale.FrBe,
        _a[Locale.Fr_Ch] = GqlTsLocale.FrCh,
        _a[Locale.Fr_Fr] = GqlTsLocale.FrFr,
        _a[Locale.It_It] = GqlTsLocale.ItIt,
        _a[Locale.Nl_Be] = GqlTsLocale.NlBe,
        _a[Locale.Nl_Nl] = GqlTsLocale.NlNl,
        _a)[locale]);
};
export var getFormDataBody = function (query, variables, assocMap) {
    var map = {};
    var body = new FormData();
    body.append('operations', JSON.stringify({ query: query, variables: variables }));
    assocMap.forEach(function (_a, key) {
        var name = _a.name, value = _a.value;
        map[name] = ["variables." + key];
        body.append(name, value);
    });
    body.append('map', JSON.stringify(map));
    return body;
};
export var toGQLUrlParams = function (query) {
    return query.startsWith('?') ? query.slice(1) : query;
};
export var combineQueryWithFragments = function () {
    var gqlQueries = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        gqlQueries[_i] = arguments[_i];
    }
    return gqlQueries.join('');
};
